import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import fancybox from '@fancyapps/fancybox';

// Plugin do fancyboxa dodający metodę confirm
import fancyConfirm from '../plugins/FancyConfirm';
$.fn.fancyConfirm = fancyConfirm;

import {confirmDialog, smoothScroll, isElement} from "./Utils";

import Dropdown from './Dropdown';

// Nadpisanie domyślnych właściwości dla wszystkich instancji
$.fancybox.defaults.hash = false;
$.fancybox.defaults.focus = false;
$.fancybox.defaults.autoFocus = false;
$.fancybox.defaults.touch = false;
$.fancybox.defaults.backFocus = false;

class Globals {
    constructor() {
        this.init();
    }

    init() {
        new Dropdown();

        this.constructor.popupConfirm();
        this.constructor.scrollToElement();
        this.constructor.cloneService();
    }

    static popupConfirm = () => {
        const $body = $('body');
        $body.on('click', '[data-confirm]', function(e) {
            const $this = $(this);
            const href = $this.attr('href');

            confirmDialog(e, value => {
                if (value) {
                    const method = $this.attr('data-method');
                    if (method) {
                        const form = document.createElement('form');
                        form.setAttribute('action', href);
                        form.setAttribute('method', method);

                        const ref = $this.attr('data-ref');
                        if (ref) {
                            const input = document.createElement('input');
                            input.type = "hidden";
                            input.name = "ref";
                            input.value = ref;
                            form.appendChild(input);
                        }
                        if(window.csrfParam && window.csrfToken){
                            const csrfInput = document.createElement('input');
                            csrfInput.type = "hidden";
                            csrfInput.name = window.csrfParam;
                            csrfInput.value = window.csrfToken;
                            form.appendChild(csrfInput);
                        }
                        document.body.appendChild(form);
                        form.submit();
                    } else {
                        window.location.href = href;
                    }
                    return true;
                } else {
                    return false;
                }
            });
        });

        window.fancyConfirm = $body.fancyConfirm;
    };

    static scrollToElement = () => {
        const elements = document.querySelectorAll('[data-scroll-to]');
        if (!elements.length) return false;

        elements.forEach(element => {
            element.addEventListener('click', e => {
                e.preventDefault();
                const target = element.getAttribute('data-scroll-to');
                smoothScroll(target, true);
            });
        });
    };

    /**
     * Klonuje elementy zawierające atrybuty data-clone
     */

    static cloneService = cb => {
        const elements = document.querySelectorAll('[data-clone]');

        if (elements.length) {
            elements.forEach(element => {
                const target = element.getAttribute('data-clone');
                if (target === null) return false;

                const clonedNode = element.cloneNode(true);
                clonedNode.removeAttribute('data-clone');
                clonedNode.setAttribute('data-cloned', '');

                const targetElement = document.querySelector(target);
                if (targetElement && isElement(targetElement)) {
                    targetElement.appendChild(clonedNode);
                }
            });

            if (typeof cb === "function") {
                cb();
            }
        }
    }
}

export default Globals;



// WEBPACK FOOTER //
// ./src/assets/js/common/Globals.js